import {
  drybulkCargoOperationsService,
  type EquipmentRequest,
} from "@services/drybulkCargoOperationsApi";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { runTransaction } from "@telemetry/runTransaction";
import { DRYBULK_CARGO_OPS_QUERY_KEYS, DRYBULK_CARGO_OPS_TELEMETRY } from "../constants";

/** DBCO-0048 - the Loaders of the operation's live port, the active Hoppers and the Transporters; read when the panel opens. */
export const useEquipmentOptions = (operationId: string, enabled: boolean) =>
  useQuery({
    queryKey: DRYBULK_CARGO_OPS_QUERY_KEYS.equipmentOptions(operationId),
    queryFn: () => drybulkCargoOperationsService.getEquipmentOptions(operationId),
    enabled,
    staleTime: 0,
    refetchOnWindowFocus: false,
    retry: false,
  });

/** DBCO-0048 (R-40) - assigns or changes the equipment of a sequence; the detail is refetched on success. */
export const useAssignEquipment = (operationId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ sequenceId, request }: { sequenceId: string; request: EquipmentRequest }) =>
      runTransaction(
        {
          module: DRYBULK_CARGO_OPS_TELEMETRY.module,
          screen: DRYBULK_CARGO_OPS_TELEMETRY.sequencesScreen,
          action: "assign-equipment",
          entityType: "cargo_operation",
          entityId: operationId,
        },
        (transactionId) =>
          drybulkCargoOperationsService.assignEquipment(operationId, sequenceId, request, {
            transactionId,
          }),
      ),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: DRYBULK_CARGO_OPS_QUERY_KEYS.detail(operationId) }),
  });
};
